export const FETCH_EPG_LINEAUP_INIT = 'FETCH_EPG_LINEAUP_INIT';
export const FETCH_EPG_LINEAUP_SUCCESS = 'FETCH_EPG_LINEAUP_SUCCESS';
export const FETCH_EPG_LINEAUP_ERROR = 'FETCH_EPG_LINEAUP_ERROR';